import { connect } from 'react-redux';

import DeactivateIntegrationView from './view.jsx';
import { deactivateIntegration, deactivateV2Integration, deactivateHubspotIntegration } from 'src/legacy/redux/actions/integrations.jsx';
import withUseHooks from '../withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  return {
    admin: state.users.me.admin,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deactivateIntegration: (type) => {
      return dispatch(deactivateIntegration(type));
    },
    deactivateV2Integration: (type) => {
      return dispatch(deactivateV2Integration(type));
    },
    deactivateHubspotIntegration: (id) => {
      return dispatch(deactivateHubspotIntegration(id));
    }
  }
}

const DeactivateIntegrationContainer = connect (
    mapStateToProps,
    mapDispatchToProps
)(DeactivateIntegrationView);

export default withUseHooks(DeactivateIntegrationContainer);
